import Image from "next/image";
import { Blocks, MessageSquareCode } from "lucide-react";

import { cn } from "@/lib/utils";

type IntegrationBrandIconProps = {
  slug: string;
  size?: "sm" | "md" | "lg";
};

const sizeClasses = {
  sm: "size-4",
  md: "size-5",
  lg: "size-8",
} as const;

export function IntegrationBrandIcon({
  slug,
  size = "md",
}: IntegrationBrandIconProps) {
  const dimensionClass = sizeClasses[size];

  if (slug === "slack") {
    return (
      <Image
        src="/cooperly/slack-icon-2019.svg"
        alt=""
        aria-hidden
        width={32}
        height={32}
        className={dimensionClass}
      />
    );
  }

  if (slug === "telegram") {
    return (
      <Image
        src="/cooperly/telegram-logo.svg"
        alt=""
        aria-hidden
        width={32}
        height={32}
        className={dimensionClass}
      />
    );
  }

  if (slug === "mcp-server") {
    return (
      <Image
        src="/cooperly/mcp-server.svg"
        alt=""
        aria-hidden
        width={32}
        height={32}
        className={dimensionClass}
      />
    );
  }

  if (slug === "claude") {
    return (
      <Image
        src="/cooperly/claude.svg"
        alt=""
        aria-hidden
        width={32}
        height={32}
        className={dimensionClass}
      />
    );
  }

  if (slug === "chatgpt") {
    return (
      <Image
        src="/cooperly/chatgpt.svg"
        alt=""
        aria-hidden
        width={32}
        height={32}
        className={dimensionClass}
      />
    );
  }

  if (slug === "linear") {
    return (
      <Image
        src="/cooperly/linear-logo.svg"
        alt=""
        aria-hidden
        width={32}
        height={32}
        className={dimensionClass}
      />
    );
  }

  if (slug === "notion") {
    return (
      <Image
        src="/cooperly/notion.svg"
        alt=""
        aria-hidden
        width={32}
        height={32}
        className={dimensionClass}
      />
    );
  }

  if (slug === "clickup") {
    return (
      <Image
        src="/cooperly/clickup.svg"
        alt=""
        aria-hidden
        width={32}
        height={32}
        className={dimensionClass}
      />
    );
  }

  if (slug === "asana") {
    return (
      <Image
        src="/cooperly/asana-logo.svg"
        alt=""
        aria-hidden
        width={32}
        height={32}
        className={dimensionClass}
      />
    );
  }

  const FallbackIcon = slug.includes("mcp") ? Blocks : MessageSquareCode;

  return <FallbackIcon className={cn(dimensionClass, "text-foreground/72")} />;
}
